module.exports = __webpack_public_path__ + "img/TFF-logo.2aa16208.png";